import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import type { Complaint } from '../types/care';
interface ComplaintCardProps {
  complaint: Complaint;
  onSelect: () => void;
}
export function ComplaintCard({
  complaint,
  onSelect
}: ComplaintCardProps) {
  const meta = complaint.page ? 'Naar ecc-longcovid.com' : `${complaint.treatmentSlugs.length} ${complaint.treatmentSlugs.length === 1 ? 'behandeling' : 'behandelingen'}`;
  return <button type="button" onClick={onSelect} className="group flex h-full w-full flex-col overflow-hidden rounded-2xl bg-white text-left ring-1 ring-line transition-shadow duration-150 hover:shadow-[0_12px_32px_-16px_rgba(3,59,74,0.35)] focus-visible:ring-2 focus-visible:ring-primary" data-id="element-61" data-mp="3pumk6kcabm91">
      <div className="aspect-[16/10] w-full overflow-hidden bg-surface" data-id="element-62" data-mp="3l0ru8z636b1i">
        <img src={complaint.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.04]" data-id="element-63" data-mp="clrpy0thgh9z" />
      </div>
      <div className="flex flex-1 flex-col px-4 pb-4 pt-3.5" data-id="element-64" data-mp="1dq1k349sasud">
        <h3 className="font-display text-[17px] font-semibold leading-snug text-ink" data-id="element-65" data-mp="18um68cbs0wxy">{complaint.title}</h3>
        <span className="mt-auto flex items-center justify-between pt-3 text-sm text-muted" data-id="element-66" data-mp="1njs5g0am6n5u">
          {meta}
          <ArrowRightIcon className="h-4 w-4 text-primary transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-67" data-mp="1iq63b222u1oa" />
        </span>
      </div>
    </button>;
}